import { useEffect, useState } from 'react'
import { getNextWebinarSlot, WebinarSlot } from './webinarSchedule'
// React hook that returns the next webinar slot and refreshes every minute
// so the label transitions correctly across slot boundaries (10:00/13:00/20:00).
export function useWebinarSlot(): WebinarSlot {
  const [slot, setSlot] = useState<WebinarSlot>(() => getNextWebinarSlot())
  useEffect(() => {
    const update = () => setSlot(getNextWebinarSlot())
    update()
    const interval = setInterval(update, 60 * 1000)
    return () => clearInterval(interval)
  }, [])
  return slot
}
